const each = (collection, iteratee) => {
  if (Array.isArray(collection)) {
    collection.forEach(iteratee);
  } else if (collection && typeof collection === 'object') {
    Object.keys(collection).forEach(key => iteratee(collection[key], key));
  }
};

const filter = (arr, predicate) => Array.prototype.filter.call(arr, predicate);

const map = (arr, iteratee) => Array.prototype.map.call(arr, iteratee);

const includes = (arrOrStr, value) => {
  if (Array.isArray(arrOrStr) || typeof arrOrStr === 'string') {
    return arrOrStr.includes(value);
  }
  if (arrOrStr && typeof arrOrStr === 'object') {
    return Object.values(arrOrStr).includes(value);
  }
  return false;
};

const fromPairs = arr => Object.fromEntries(arr);

const isEmpty = obj =>
  obj == null ||
  (Array.isArray(obj) && obj.length === 0) ||
  (typeof obj === 'object' && Object.keys(obj).length === 0);

function remove(arr, predicate) {
  arr.forEach((ele, i) => {
    if (predicate(ele)) {
      arr.splice(i, 1);
    }
  });
}

/* eslint-disable */ // :) too much red ATM
function buildAddOnManagerFunctions() {
  var groupMinMaxValidation = {};
  var allDependencyRecordsCached = [];
  var commercialProductAddOnAssociationListCached = [];
  var mapAssocIdAssocRecord = {};
  var currentCommercialProductId = '';
  var currentCommercialProductIdDetails = {};
  var currentCampaignPromotionSelId = '';
  var cachedDependencyData = {};
  var useDependencyEngine = false;
  var usedAutomaticInclusions = [];
  var usedAutomaticDeletions = [];

  /*
  * init
  *
  * Initializes the following data used by the Add On Manager:
  * current commercial product id, commercial product add on associations list and map and
  * add on dependency records.
  *
  * Input parameters are: commercial product id,Campaign Promotion ID, commercial product add on associations and
  * add on dependency records.
  */
  /*
  * ServiceFee --Added priceItemList argument in init
  * priceItemList: list of commercialProductIds i.e sf object id of source and target
  */
  function init(commercialProductId,campaignPromotionIDSelected, associationRecords, allDependencyRecords, isMACD, useDependencyEngineFlag, priceItemList) {
    useDependencyEngine = useDependencyEngineFlag;
    currentCommercialProductId = commercialProductId;
    currentCommercialProductIdDetails = priceItemList;//ServiceFee
    currentCampaignPromotionSelId=campaignPromotionIDSelected;
    mapAssocIdAssocRecord = {};
    commercialProductAddOnAssociationListCached = [];
    each(associationRecords, function (assoc) {
      assoc = Object.keys(assoc).reduce((c, k) => (c[k.toLowerCase()] = assoc[k], c), {});
      commercialProductAddOnAssociationListCached.push(assoc);
      mapAssocIdAssocRecord[assoc.id] = assoc;
    });
    each(allDependencyRecords, function (depRec) {
      depRec = Object.keys(depRec).reduce((c, k) => (c[k.toLowerCase()] = depRec[k], c), {});
      if(!allDependencyRecordsCached.some(dependencyrecord => dependencyrecord.name === depRec.name))
        allDependencyRecordsCached.push(depRec);
    });
    //allDependencyRecordsCached = allDependencyRecords;
    usedAutomaticInclusions = [];
    usedAutomaticDeletions = [];

    if (isMACD !== undefined && useDependencyEngine) {
      allDependencyRecordsCached = filter(allDependencyRecordsCached, function (dependencyItem) {
        if ((isMACD && dependencyItem.order_type__c === 'MACD') || (!isMACD && dependencyItem.order_type__c === 'New Order') || (dependencyItem.order_type__c === '' || dependencyItem.order_type__c === undefined)) {
          return true;
        }

        return false;
      });
    }
  }

  /*
  * getCurrentCommercialProductId
  *
  * Returns the id of the commercial product currently set in the Add On Manager.
  */
  function getCurrentCommercialProductId() {
    return currentCommercialProductId;
  }

  /*ServiceFee
  * getCurrentCommercialProductDetails
  *
  * Returns the Details(Product Definition name and Subtype) of the commercial product currently set in the Add On Manager.
  */
  function getCurrentCommercialProductDetails() {
    return currentCommercialProductIdDetails;
  }
  /*
  * getCurrentCommercialProductId
  *
  * Returns the id of the campaign promotion currently set in the Add On Manager.
  */
  function getCurrentCampaignPromotionId() {
    return currentCampaignPromotionSelId;
  }
  /*
  * getCurrentCommercialProductId
  *
  * sets the id of the campaign promotion currently set in the Add On Manager.
  */
  function setCurrentCampaignPromotionId(campaignPromotionID) {
    currentCampaignPromotionSelId=campaignPromotionID;
  }

  /*
  * prepareDependencyMapsForCommercialProduct
  *
  * Dependency records from table AddOn_Dependency__c are being processed and
  * maps which will be used in AddOn Dependency engine are being populated and prepared
  *
  * Input parameters are:
  * currentlySelectedAddOnAssocIds // List of all currently selected Association AddOn Ids - { 'id1', 'id2' .. }
  *
  * Return parameters are:
  * resultMap = { allOptionalAddOnDependencies: {}, mapAssocIdRelatedDependencies: {}, allSatisfiedMandatoryAddOnDependencies: {}, allExcludedAddOnDependencies: {} };
  */
  function prepareDependencyMapsForCommercialProduct(currentlySelectedAddOnAssocIds) {
    var resultMap = { allMandatoryRules: {}, allOptionalAddOnDependencies: {}, mapAssocIdRelatedDependencies: {}, allSatisfiedMandatoryAddOnDependencies: {}, allExcludedAddOnDependencies: {}, allInclusionAddOnDependencies: {}, satisfiedInclusionAddOnDependencies: {}, allServiceFeeRules : {} };
    var allSatisfiedMandatoryAddOnDependencies = {};
    var mapAssocIdRelatedDependencies = {};
    var allOptionalAddOnDependencies = {};
    var allExcludedAddOnDependencies = {};
    var allInclusionAddOnDependencies = {};
    var satisfiedInclusionAddOnDependencies = [];
    var allMandatoryRules = {};
    var allServiceFeeRules = {};


    groupMinMaxValidation = buildAssociationGroups(commercialProductAddOnAssociationListCached);

    var groupCounts = getAssociationGroupCounts(commercialProductAddOnAssociationListCached, currentlySelectedAddOnAssocIds);

    each(commercialProductAddOnAssociationListCached, function (assoc) {
      var count = groupCounts[assoc.cspmb__group__c];
      groupMinMaxValidation[assoc.cspmb__group__c].current_count = isNaN(Number(count)) ? 0 : Number(count);
    });

    if (useDependencyEngine) {
      // Preparing all inclusion records.
      allInclusionAddOnDependencies = filter(allDependencyRecordsCached, function (dependencyItem) {
        if (dependencyItem.type__c === 'Inclusion' &&
          ((dependencyItem.price_item__c !== undefined && dependencyItem.price_item__c === getCurrentCommercialProductId()) ||
            dependencyItem.price_item__c === undefined)) {
          return true;
        }

        return false;
      });
      //if there is any campaign rules needs to be cached as mandatory rules
      allMandatoryRules = filter(allDependencyRecordsCached, function (dependencyItem) {
        if (dependencyItem.type__c === 'Mandatory' &&
          ((dependencyItem.price_item__c !== undefined && dependencyItem.price_item__c === getCurrentCommercialProductId()) ||
            dependencyItem.price_item__c === undefined) && (dependencyItem.campaign_promotion_source__c === undefined ||
            (dependencyItem.campaign_promotion_source__c !== undefined && dependencyItem.campaign_promotion_source__c === getCurrentCampaignPromotionId()))) {

          return true;
        }

        return false;
      });

      //identify all service fee related dependancy rules
      allServiceFeeRules = filter(allDependencyRecordsCached, function (dependencyItem) {
        if ((dependencyItem.type__c === 'Mandatory' || dependencyItem.type__c === 'Automatic Inclusion')
          && dependencyItem.operation__c
          && ((dependencyItem.price_item__c !== undefined && dependencyItem.price_item__c === getCurrentCommercialProductId()) ||
            dependencyItem.price_item__c === undefined)
          && ((dependencyItem.price_item_product_definition__c && productFamilyRule(dependencyItem, getCurrentCommercialProductDetails())) || (dependencyItem.price_item_product_definition__c === undefined && dependencyItem.price_item__c !== undefined))//ServiceFee
          && (dependencyItem.campaign_promotion_source__c === undefined ||
            (dependencyItem.campaign_promotion_source__c !== undefined && dependencyItem.campaign_promotion_source__c === getCurrentCampaignPromotionId()))) {

          return true;
        }

        return false;
      });

      if(currentlySelectedAddOnAssocIds.length > 0) {
        each(currentlySelectedAddOnAssocIds, function (assocId) {
          var assocRecord = mapAssocIdAssocRecord[assocId];

          if (assocRecord !== undefined) {
            each(allDependencyRecordsCached, function (dependencyItem) {
              if ((dependencyItem.price_item__c !== undefined && dependencyItem.price_item__c === assocRecord.cspmb__price_item__c) ||
                dependencyItem.price_item__c === undefined) {
                // optional group dependencies does not need to be processed within regular dependency check
                if (dependencyItem.type__c === 'Optional' &&
                  ((dependencyItem.group_source__c != undefined && dependencyItem.group_source__c !== '') ||
                    (dependencyItem.add_on_source__c !== '' && dependencyItem.add_on_source__c !== undefined)) &&
                  ((dependencyItem.group_target__c != undefined && dependencyItem.group_target__c !== '') ||
                    (dependencyItem.add_on_target__c !== '' && dependencyItem.add_on_target__c !== undefined))) {
                  if (allOptionalAddOnDependencies[assocRecord.id] === undefined) {
                    allOptionalAddOnDependencies[assocRecord.id] = [];
                  }
                  allOptionalAddOnDependencies[assocRecord.id].push(dependencyItem);

                  // check with Marijan why this OPTIONALS are being added
                  if (dependencyItem.add_on_target__c !== undefined) {
                    if (allOptionalAddOnDependencies[dependencyItem.add_on_target__c] === undefined) {
                      allOptionalAddOnDependencies[dependencyItem.add_on_target__c] = [];
                    }
                    allOptionalAddOnDependencies[dependencyItem.add_on_target__c].push(dependencyItem);
                  }
                } else {
                  if (dependencyItem.group_source__c !== '' && dependencyItem.group_source__c !== undefined) {
                    if (assocRecord.cspmb__group__c === dependencyItem.group_source__c) {
                      if (mapAssocIdRelatedDependencies[assocRecord.id] === undefined) {
                        mapAssocIdRelatedDependencies[assocRecord.id] = [];
                      }

                      mapAssocIdRelatedDependencies[assocRecord.id].push(dependencyItem);
                    }
                  } else if (dependencyItem.add_on_source__c !== '' && dependencyItem.add_on_source__c !== undefined) {
                    if (assocRecord.cspmb__add_on_price_item__c === dependencyItem.add_on_source__c) {
                      if (mapAssocIdRelatedDependencies[assocRecord.id] === undefined) {
                        mapAssocIdRelatedDependencies[assocRecord.id] = [];
                      }

                      mapAssocIdRelatedDependencies[assocRecord.id].push(dependencyItem);
                    }
                  } else if (dependencyItem.price_item__c !== '' && dependencyItem.price_item__c !== undefined) {
                    if (mapAssocIdRelatedDependencies[assocRecord.id] === undefined) {
                      mapAssocIdRelatedDependencies[assocRecord.id] = [];
                    }

                    mapAssocIdRelatedDependencies[assocRecord.id].push(dependencyItem);
                  } else if ((dependencyItem.add_on_source__c === undefined || dependencyItem.add_on_source__c === '') &&
                    (dependencyItem.group_source__c === undefined || dependencyItem.group_source__c === '') &&
                    dependencyItem.type__c !== 'Mandatory') {
                    if (mapAssocIdRelatedDependencies[assocRecord.id] === undefined) {
                      mapAssocIdRelatedDependencies[assocRecord.id] = [];
                    }

                    mapAssocIdRelatedDependencies[assocRecord.id].push(dependencyItem);
                  }

                  // mandatory addon dependencies
                  if (dependencyItem.type__c === 'Mandatory' &&
                    dependencyItem.add_on_target__c != undefined && dependencyItem.add_on_target__c !== '' &&
                    /*(dependencyItem.campaign_promotion_source__c === undefined || (dependencyItem.campaign_promotion_source__c !== undefined && dependencyItem.campaign_promotion_source__c === getCurrentCampaignPromotionId())) &&*/
                    (dependencyItem.add_on_target__c === assocRecord.cspmb__add_on_price_item__c || dependencyItem.add_on_source__c === assocRecord.cspmb__add_on_price_item__c)) {
                    if (allSatisfiedMandatoryAddOnDependencies[assocRecord.id] === undefined) {
                      allSatisfiedMandatoryAddOnDependencies[assocRecord.id] = [];
                    }
                    allSatisfiedMandatoryAddOnDependencies[assocRecord.id].push(dependencyItem);
                  } else if (dependencyItem.type__c === 'Exclusion') {
                    if (dependencyItem.add_on_source__c != undefined && dependencyItem.add_on_source__c !== '' &&
                      (dependencyItem.add_on_source__c === assocRecord.cspmb__add_on_price_item__c)) { // exclusion addon dependencies
                      if (allExcludedAddOnDependencies[assocRecord.id] === undefined) {
                        allExcludedAddOnDependencies[assocRecord.id] = [];
                      }
                      allExcludedAddOnDependencies[assocRecord.id].push(dependencyItem);
                    } else if (dependencyItem.group_source__c != undefined && dependencyItem.group_source__c !== '' &&
                      (dependencyItem.group_source__c === assocRecord.cspmb__group__c)) { // exclusion group dependencies
                      if (allExcludedAddOnDependencies[assocRecord.id] === undefined) {
                        allExcludedAddOnDependencies[assocRecord.id] = [];
                      }
                      allExcludedAddOnDependencies[assocRecord.id].push(dependencyItem);
                    }
                    else if ((dependencyItem.add_on_source__c === undefined || dependencyItem.add_on_source__c === '') &&
                      (dependencyItem.group_source__c === undefined || dependencyItem.group_source__c === '')) {
                      if (allExcludedAddOnDependencies[assocRecord.id] === undefined) {
                        allExcludedAddOnDependencies[assocRecord.id] = [];
                      }

                      allExcludedAddOnDependencies[assocRecord.id].push(dependencyItem);
                    }
                  }
                }
              }
            });

            // Filtering records for each selected add on.
            allInclusionAddOnDependencies = filter(allInclusionAddOnDependencies, function (inclusionDependencyItem) {
              var isDependency = false;
              if (inclusionDependencyItem.add_on_source__c !== undefined && inclusionDependencyItem.add_on_source__c !== '' && inclusionDependencyItem.add_on_source__c === assocRecord.cspmb__add_on_price_item__c) {
                isDependency = true;
              }

              if (inclusionDependencyItem.group_source__c !== undefined && inclusionDependencyItem.group_source__c !== '' && inclusionDependencyItem.group_source__c === assocRecord.cspmb__group__c) {
                isDependency = true;
              }

              if (inclusionDependencyItem.group_source__c === undefined && inclusionDependencyItem.add_on_source__c === undefined) {
                isDependency = true;
              }

              if (isDependency) {
                satisfiedInclusionAddOnDependencies.push(inclusionDependencyItem);
              }

              return !isDependency;
            });
          }
        });
      } else {
        each(allDependencyRecordsCached, function (dependencyItem) {
          if ((dependencyItem.price_item__c !== undefined && dependencyItem.price_item__c === getCurrentCommercialProductId()) ||
            dependencyItem.price_item__c === undefined) {

            if (dependencyItem.type__c === 'Inclusion' &&
              (dependencyItem.add_on_source__c === undefined || dependencyItem.add_on_source__c === '') &&
              (dependencyItem.group_source__c === undefined || dependencyItem.group_source__c === '')) {
              if (mapAssocIdRelatedDependencies['priceItemLevel'] === undefined) {
                mapAssocIdRelatedDependencies['priceItemLevel'] = [];
              }

              mapAssocIdRelatedDependencies['priceItemLevel'].push(dependencyItem);
            } else if (dependencyItem.type__c === 'Exclusion') {
              if ((dependencyItem.add_on_source__c === undefined || dependencyItem.add_on_source__c === '') &&
                (dependencyItem.group_source__c === undefined || dependencyItem.group_source__c === '')) {
                if (allExcludedAddOnDependencies['priceItemLevel'] === undefined) {
                  allExcludedAddOnDependencies['priceItemLevel'] = [];
                }

                allExcludedAddOnDependencies['priceItemLevel'].push(dependencyItem);
              }
            } else if (dependencyItem.type__c === 'Automatic Inclusion') {
              if (dependencyItem.source_attribute__c !== '' && dependencyItem.source_attribute__c !== undefined) {
                if (mapAssocIdRelatedDependencies['priceItemLevel'] === undefined) {
                  mapAssocIdRelatedDependencies['priceItemLevel'] = [];
                }

                mapAssocIdRelatedDependencies['priceItemLevel'].push(dependencyItem);
              }
            }
          }
        });

        // Filtering records for each selected add on.
        allInclusionAddOnDependencies = filter(allInclusionAddOnDependencies, function (inclusionDependencyItem) {
          var isDependency = false;

          if (inclusionDependencyItem.group_source__c === undefined && inclusionDependencyItem.add_on_source__c === undefined) {
            isDependency = true;
          }

          if (isDependency) {
            satisfiedInclusionAddOnDependencies.push(inclusionDependencyItem);
          }

          return !isDependency;
        });
      }

      mapAssocIdRelatedDependencies = sortMapBySequence(mapAssocIdRelatedDependencies);
      allOptionalAddOnDependencies = sortMapBySequence(allOptionalAddOnDependencies);
      allSatisfiedMandatoryAddOnDependencies = sortMapBySequence(allSatisfiedMandatoryAddOnDependencies);
      allExcludedAddOnDependencies = sortMapBySequence(allExcludedAddOnDependencies);
      allInclusionAddOnDependencies = sortListBySequence(allInclusionAddOnDependencies);
    }

    resultMap.allOptionalAddOnDependencies = allOptionalAddOnDependencies;
    resultMap.allSatisfiedMandatoryAddOnDependencies = allSatisfiedMandatoryAddOnDependencies;
    resultMap.allExcludedAddOnDependencies = allExcludedAddOnDependencies;
    resultMap.allInclusionAddOnDependencies = allInclusionAddOnDependencies;
    resultMap.mapAssocIdRelatedDependencies = mapAssocIdRelatedDependencies;
    resultMap.satisfiedInclusionAddOnDependencies = satisfiedInclusionAddOnDependencies;
    resultMap.allMandatoryRules = allMandatoryRules;
    resultMap.allServiceFeeRules = allServiceFeeRules;

    cachedDependencyData = resultMap;

    return resultMap;
  }

  //ServiceFee
  function productFamilyRule(dependencyItem, currentCommercialProductIdDetails){
    var pIProdDef;
    var pISubType;
    var text;
    var priceItemvar = {};

    if(dependencyItem.price_item_product_definition__c) {
      text = 'PriceItem';
      pIProdDef = dependencyItem.price_item_product_definition__c;
      if(dependencyItem.price_item_sub_types__c) {
        pISubType = dependencyItem.price_item_sub_types__c;
      }
    }

    priceItemvar = filter(currentCommercialProductIdDetails, function (pi) {
      if(text === 'PriceItem') {
        if(dependencyItem.price_item_product_definition__c && dependencyItem.price_item_sub_types__c ) {
          if(dependencyItem.price_item_product_definition__c === pi.Product_Definition_Name__c && dependencyItem.price_item_sub_types__c === pi.Sub_Type__c ) {
            return true;
          }
        }
        else if(dependencyItem.price_item_product_definition__c && dependencyItem.price_item_sub_types__c === undefined) {
          if(dependencyItem.price_item_product_definition__c === pi.Product_Definition_Name__c)
            return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    });
    return priceItemvar;
  }

  /*
  * sortMapBySequence
  *
  * Sort each list in the map based on the sequence field on the SF record.
  *
  * Input parameter: map to sort, map is association id -> list of related dependency items.
  *
  * Returns the same map with all lists sorted.
  */
  function sortMapBySequence(mapToSort) {
    // sort populated Sequence first and then undefined values
    each(mapToSort, function (listItems, key) {
      listItems = sortListBySequence(listItems);
    });

    return mapToSort;
  }

  /*
  * sortListBySequence
  *
  * Sort the list on the sequence field on the SF record.
  *
  * Input parameter: list to sort.
  *
  * Returns the sorted list.
  */
  function sortListBySequence(listToSort) {
    listToSort.sort(function (a, b) {
      if (a.sequence__c === undefined) {
        return 1;
      } else if (b.sequence__c === undefined) {
        return -1;
      } else {
        return a.sequence__c - b.sequence__c;
      }
    });

    return listToSort;
  }

  /*
  * buildAssociationGroups
  *
  * Build groups and min and max for it.
  *
  * Input parameter: associations to analyse.
  *
  * Returns the map name -> group data (min, max, count).
  */
  function buildAssociationGroups(assocs) {
    var groups = {};
    each(assocs, function (assoc) {
      var name = assoc.cspmb__group__c;
      groups[name] = {
        max_count: isNaN(Number(assoc.cspmb__max__c)) ? 1000 : Number(assoc.cspmb__max__c),
        min_count: isNaN(Number(assoc.cspmb__min__c)) ? 0 : Number(assoc.cspmb__min__c),
        current_count: 0
      };
    });
    return groups;
  }

  /*
  * getAssociationGroupCounts
  *
  * Get count of added AddOns for each related product and group.
  *
  * Input parameter: associations to analyse and currently selected asociations.
  *
  * Returns the group counts.
  */
  function getAssociationGroupCounts(assocs, selectedAddOnAssocIds) {
    var groupCounts = {};
    var assocsById = fromPairs(map(assocs, function (assoc) {
      return [assoc.id, assoc];
    }));

    each(selectedAddOnAssocIds, function (id) {
      var assoc = assocsById[id];
      if (assoc) {
        var count = groupCounts[assoc.cspmb__group__c] || (groupCounts[assoc.cspmb__group__c] = 0);
        groupCounts[assoc.cspmb__group__c] = count + 1;
      }
    });

    return groupCounts;
  }

  /*
  * preDrawAssociationListFiltering
  *
  * Performs the pre draw filtering of the available add ons baded on min-max
  * exclusion and inclusion dependencies.
  *
  * Input parameter: all selected add on association ids
  *
  * Returns the filtered list with the following information:
  * { assoc, isAvailable, unavailableReason, max, isExcluded };
  */
  function preDrawAssociationListFiltering(assocsForRelatedProduct, selectedAddOnAssocIdsForRelatedProduct, currentlySelectedAddOnAssocIdsAllRelatedProducts) {
    prepareDependencyMapsForCommercialProduct(currentlySelectedAddOnAssocIdsAllRelatedProducts);

    var groupCounts = getAssociationGroupCounts(commercialProductAddOnAssociationListCached, selectedAddOnAssocIdsForRelatedProduct);
    var excludedAddOns = getExcludedAddOns();
    var excludedGroups = getExcludedGroups();
    var mapMandatoryTargetAddOnIds = getAllMandatoryTargetAddOns();

    assocsForRelatedProduct = filter(assocsForRelatedProduct, function(assoc) {
      return assoc.is_active__c && assoc.cspmb__add_on_price_item__r.cspmb__is_active__c;
    });

    return map(assocsForRelatedProduct, function (assoc) {
      var isAvailable = true;
      var reason = '';
      var isExcluded = false;

      var grp = groupMinMaxValidation[assoc.cspmb__group__c];
      var max = grp.max_count;

      if (!checkForGroupMax(assoc, groupCounts)) {
        isAvailable = false;
        reason += 'The max for group ' + assoc.cspmb__group__c + ' has been exceeded. ';
      }

      if (useDependencyEngine) {
        if (!checkForExclusionRules(assoc, excludedAddOns, excludedGroups)) {
          isExcluded = true;
        }

        if ((!checkForInclusionRules(assoc) || mapMandatoryTargetAddOnIds[assoc.cspmb__add_on_price_item__c] !== undefined)) {
          isAvailable = false;
          reason += 'Add On does not satisfy the inclusion rules. ';
        }
      }

      return { assoc: assoc, isAvailable: isAvailable, unavailableReason: reason, max: max, isExcluded: isExcluded };
    });
  }

  /*
  * getExcludedAddOns
  *
  * Gets the comma separated list of excluded add on names.
  *
  * Returns the comma separated list of excluded add on names.
  */
  function getExcludedAddOns() {
    var excludedAddOns = '';
    each(cachedDependencyData.allExcludedAddOnDependencies, function (it) {
      each(it, function (i) {
        if (i.add_on_target__c != undefined) {
          // mismatch
          excludedAddOns += i.add_on_target__r.name;
          excludedAddOns += ',';
        }
      });
    });
    return excludedAddOns;
  }

  /*
  * getExcludedAddOns
  *
  * Gets the comma separated list of excluded add on names.
  *
  * Returns the comma separated list of excluded add on names.
  */
  function getExcludedGroups() {
    var excludedGroups = '';
    each(cachedDependencyData.allExcludedAddOnDependencies, function (it) {
      each(it, function (i) {
        if (i.group_target__c != undefined) {
          excludedGroups += i.group_target__c;
          excludedGroups += ',';
        }
      });
    });
    return excludedGroups;
  }

  function getMandatoryTargetAddOns() {
    var listOfMandatoryAddOnIds = {};

    each(cachedDependencyData.allSatisfiedMandatoryAddOnDependencies, function (it) {
      each(it, function (i) {
        if (i.add_on_target__c !== undefined) {
          listOfMandatoryAddOnIds[i.add_on_target__c] = i.add_on_target__c;
        }
      });
    });

    return listOfMandatoryAddOnIds;
  }

  function getAllMandatoryTargetAddOns() {
    var listOfMandatoryAddOnIds = {};

    each(cachedDependencyData.allMandatoryRules, function (it) {
      if (it.add_on_target__c !== undefined) {
        listOfMandatoryAddOnIds[it.add_on_target__c] = it.add_on_target__c;
      }
    });

    return listOfMandatoryAddOnIds;
  }

  /*
  * checkForMinMax
  *
  * Checks if the group maximum is exceeded and updates the counter data.
  *
  * Input parameter: association to check and all group counts.
  *
  * Returns false if max is exceeded, true if it is not.
  */
  function checkForGroupMax(assoc, groupCounts) {
    var grp = groupMinMaxValidation[assoc.cspmb__group__c];
    var max = grp.max_count;
    var count = groupCounts[assoc.cspmb__group__c];

    groupMinMaxValidation[assoc.cspmb__group__c].current_count = isNaN(Number(count)) ? 0 : Number(count);

    // mismatch
    if (count > max) {
      return false;
    }

    return true;
  }

  /*
  * checkForExclusionRules
  *
  * Checks if the add on has been included based on add on dependency inclusion rules.
  *
  * Input parameter: association to check and all excluded add ons
  * prepared in the getExcludedAddOns.
  *
  * Returns false if the add on is excluded, false if it is not.
  */
  function checkForExclusionRules(assoc, excludedAddOns, excludedGroups) {
    var excludedAddOnsList = excludedAddOns.split(',');
    var excludedGroupsList = excludedGroups.split(',');
    if (excludedAddOnsList.indexOf(assoc.cspmb__add_on_price_item__r.name) != -1 || excludedGroupsList.indexOf(assoc.cspmb__group__c) != -1) {
      return false;
    }

    return true;
  }

  /*
  * checkForInclusionRules
  *
  * Checks if the add on has been included based on add on dependency inclusion rules.
  *
  * Input parameter: association to check.
  *
  * Returns false if the add on is not included, false if it is.
  */
  function checkForInclusionRules(assoc) {
    var flag = true;
    var satisfied = false;
    each(cachedDependencyData.satisfiedInclusionAddOnDependencies, function (satisfiedInclusionDependencyItem) {
      if (satisfiedInclusionDependencyItem.add_on_target__c != undefined && satisfiedInclusionDependencyItem.add_on_target__c !== '' && satisfiedInclusionDependencyItem.add_on_target__c === assoc.cspmb__add_on_price_item__c) {
        satisfied = true;
      }

      if (satisfiedInclusionDependencyItem.group_target__c != undefined && satisfiedInclusionDependencyItem.group_target__c !== '' && satisfiedInclusionDependencyItem.group_target__c === assoc.cspmb__group__c) {
        satisfied = true;
      }
    });

    each(cachedDependencyData.allInclusionAddOnDependencies, function (inclusionDependencyItem) {
      if (inclusionDependencyItem.add_on_target__c != undefined && inclusionDependencyItem.add_on_target__c !== '' && inclusionDependencyItem.add_on_target__c === assoc.cspmb__add_on_price_item__c) {
        flag = false;
      }

      if (inclusionDependencyItem.group_target__c != undefined && inclusionDependencyItem.group_target__c !== '' && inclusionDependencyItem.group_target__c === assoc.cspmb__group__c) {
        flag = false;
      }
    });

    return satisfied || flag;
  }

  /*
  * runDependencyEngine
  *
  * Checks the add on dependencies and decides which error messages to display and add ons to add or remove
  *
  * Input parameter:
  * currentlySelectedAddOnAssocIds: list of currently selected add on association ids.
  * additionalContext: {
  *   operation: <upgrade/downgrade/change>,
  *   itemId: <if offer is getting chage/update/downgrade then target commercialProductId>,
  *   productFamily: <can be null as of now>,
  * }
  * Returns the object with following data: addOnsFromGroupToInclude, groupsToRemove, addOnsForInclusion,
  * dependentAddOnsIdToAdd, dependentAssociationsIdToAdd, dependentAddOnsIdToDelete
  * dependentAssociationsIdToDelete, groupMinMaxValidation
  */
  function runDependencyEngine(currentlySelectedAddOnAssocIds, additionalContext) {
    var contextOperation,contextItemId, contextProductFamily;
    if(!isEmpty(additionalContext)){
      contextOperation = isEmpty(additionalContext.operation) ? contextOperation: additionalContext.operation;
      contextItemId = isEmpty(additionalContext.itemId) ? contextItemId: additionalContext.itemId;
      contextProductFamily = isEmpty(additionalContext.productFamily) ? contextProductFamily : additionalContext.productFamily;
    }
    var resultMap = {
      dependentAssociationsIdToAdd: [],
      addOnsFromGroupToInclude: [],
      groupsToRemove: [],
      addOnsToBeIncluded: {},
      dependentAddOnsIdToAdd: [],
      dependentAddOnsIdToDelete: [],
      dependentAssociationsIdToDelete: [],
      addOnsForInclusion: {},
      groupMinMaxValidation: {},
      operationToPriceItem : {},
      dependentPriceItemtoAdd : {},
      dependentPriceItemtoDelete : {}
    };

    if(useDependencyEngine) {
      var addOnsFromGroupInclusion = {};
      var groupsToRemove = [];
      var addOnsForInclusion = {};
      var dependentAddOnsIdToAdd = [];
      var dependentPriceItemtoAdd = {};
      var dependentAssociationsIdToAdd = [];
      var dependentAddOnsIdToDelete = [];
      var dependentPriceItemtoDelete = {};
      var dependentAssociationsIdToDelete = [];

      var addOnsFromGroupToInclude = [];
      var addOnsToBeIncluded = {};
      var operationToPriceItem = {};

      var mapAssocIdRelatedDependencies = cachedDependencyData.mapAssocIdRelatedDependencies;
      var allOptionalAddOnDependencies = cachedDependencyData.allOptionalAddOnDependencies;
      var allSatisfiedMandatoryAddOnDependencies = cachedDependencyData.allSatisfiedMandatoryAddOnDependencies;
      var allInclusionAddOnDependencies = cachedDependencyData.allInclusionAddOnDependencies;
      var satisfiedInclusionAddOnDependencies = cachedDependencyData.satisfiedInclusionAddOnDependencies;
      var allMandatoryRules = cachedDependencyData.allMandatoryRules;
      var allServiceFeeRules = cachedDependencyData.allServiceFeeRules;

      var currentlySelectedAddOnIds = [];
      each(currentlySelectedAddOnAssocIds, function (assocId) {
        if (assocId !== undefined && assocId !== '') {
          var assocRecord = mapAssocIdAssocRecord[assocId];
          currentlySelectedAddOnIds.push(assocRecord.cspmb__add_on_price_item__c);
        }
      });

      each(allMandatoryRules, function(dependencyRule) {
        if((dependencyRule.add_on_source__c === undefined || dependencyRule.add_on_source__c === '') &&
          (dependencyRule.group_source__c === undefined || dependencyRule.group_source__c === '') &&
          (dependencyRule.campaign_promotion_source__c === undefined || (dependencyRule.campaign_promotion_source__c !== undefined && dependencyRule.campaign_promotion_source__c === getCurrentCampaignPromotionId()))) {
          let operation = dependencyRule.operation__c;
          if(operation && !includes(operation,contextOperation)){
            return;
          }
          dependentAddOnsIdToAdd.push(dependencyRule.add_on_target__c);
        }
      });

      each(allServiceFeeRules, function(dependencyRule) {
        let operationArr = dependencyRule.operation__c ? dependencyRule.operation__c.split(';') : [] ;
        let addOnSource = dependencyRule.add_on_source__c;
        let priceItemTarget = dependencyRule.price_item_target__c;
        //let priceItemTarget = dependencyRule.price_item_target__r;
        if (addOnSource){
          each(operationArr, function (operation) {
            //operation = operation.toUpperCase().replace(/ /g,'_');
            let key = operation+':'+addOnSource;
            let value = priceItemTarget;
            operationToPriceItem[key] = value;
          });
        } else {
          each(operationArr, function (operation) {
            //operation = operation.toUpperCase().replace(/ /g,'_');
            let key = operation;
            let value = priceItemTarget;
            operationToPriceItem[key] = value;
          });
        }
      });

      each(mapAssocIdRelatedDependencies, function (value, key) {
        each(value, function (childValue) {
          var targetGroup = childValue.group_target__c;
          var useGroupInclusionCheck = false;
          var quantity = isNaN(Number(childValue.quantity__c)) ? 1 : Number(childValue.quantity__c);
          var type = childValue.type__c;
          var addOnTarget = childValue.add_on_target__c;
          var priceItemTarget = childValue.price_item_target__c;
          var targetAddOnMissing = true;
          var targetAddOnName = '';
          var sequence = childValue.sequence__c;
          var operation = childValue.operation__c;

          if(operation && !includes(operation,contextOperation)){
            return;
          }

          // this is check for Target AddOn only
          // mismatch
          if (type === 'Inclusion' && childValue.add_on_target__r != undefined && childValue.add_on_target__r.name !== '') {
            // check for target add on and store the name for the message
            targetAddOnName = childValue.add_on_target__r.name;
          } else {
            // no target add ons needed for add
            targetAddOnMissing = false;
            targetAddOnName = '';
          }

          // this is check for groups
          if (type === 'Inclusion' && targetGroup !== undefined && targetGroup !== '') {
            // check if inclusion quantity check needed for this dependency record
            useGroupInclusionCheck = true;
          }

          var childValueId = childValue.id;
          if (childValueId == undefined) {
            childValueId = childValue.Id;
          }

          // if it is Mandatory then search for the missing ones
          // this is for adding all the missing add ons in bulk
          if (type === 'Mandatory' || (type === 'Automatic Inclusion' && !usedAutomaticInclusions.includes(childValueId))) {
            // store the Add On Id to check is already present or not
            dependentAddOnsIdToAdd.push(addOnTarget);
            if(!operation && priceItemTarget){
              dependentPriceItemtoAdd[childValue.id] = priceItemTarget;
            }
            //ServiceFee map of operation vs priceItem

            if(type === 'Automatic Inclusion') {
              usedAutomaticInclusions.push(childValueId);
            }
          }

          each(currentlySelectedAddOnAssocIds, function (assocId) {
            var assocRecord = mapAssocIdAssocRecord[assocId];

            if (assocRecord !== undefined) {
              // skip assoc record for which you are checking dependencies
              // if(assocRecord.id !== key) {
              if (type === 'Inclusion') {
                // check how many is missing from some specific group
                // if quantity at the end is more than 0 show message
                if (targetGroup !== undefined && targetGroup !== '' && assocRecord.cspmb__group__c === targetGroup) {
                  quantity--;
                } else if (assocRecord.cspmb__add_on_price_item__c == addOnTarget) {
                  // this is used when user wants to add more than 1 AddOn record of the same type
                  quantity--;

                  if (quantity < 1) {
                    // enough Target Add Ons already added
                    targetAddOnMissing = false;
                  }
                }
              } else if (type === 'Exclusion' || (type === 'Automatic Deletion' && !usedAutomaticDeletions.includes(childValueId))) {
                if(type === 'Exclusion') {
                  if (targetGroup !== undefined && targetGroup !== '' && assocRecord.cspmb__group__c === targetGroup) {
                    //if (!includes(groupsToRemove, targetGroup)) {
                    groupsToRemove.push({ targetGroup: targetGroup, sequence: sequence });
                    //}
                  } else if (assocRecord.cspmb__add_on_price_item__c == addOnTarget && childValue.add_on_target__r != undefined && childValue.add_on_target__r.name !== '') {
                    // this is for exclusion of add ons in bulk
                    // store the Add On Id to check is already present or not
                    if (!includes(dependentAddOnsIdToDelete, addOnTarget))
                      dependentAddOnsIdToDelete.push(addOnTarget);
                  }
                } else {
                  if (!includes(dependentAddOnsIdToDelete, addOnTarget)) {
                    dependentAddOnsIdToDelete.push(addOnTarget);
                  }
                  //if(!operation && priceItemTarget){
                  if(priceItemTarget){
                    dependentPriceItemtoDelete[childValue.id] = priceItemTarget ;
                  }
                }
              }
            }
          });

          if(type === 'Automatic Deletion') {
            usedAutomaticDeletions.push(childValueId);
          }

          if (quantity > 0 && useGroupInclusionCheck) {
            if (addOnsFromGroupInclusion[key] === undefined) {
              addOnsFromGroupInclusion[key] = [];
            }
            addOnsFromGroupInclusion[key].push(targetGroup);
          }

          // target add on missing is used in Inclusion type rules
          if (targetAddOnMissing) {
            if (addOnsForInclusion[addOnTarget] === undefined) {
              addOnsForInclusion[addOnTarget] = [];
            }

            var listItem = { targetAddOnName: targetAddOnName, quantity: quantity, operation : operation };
            addOnsForInclusion[addOnTarget].push(listItem);
          }

        });
      });

      each(currentlySelectedAddOnAssocIds, function (assocId) {
        var assocRecord = mapAssocIdAssocRecord[assocId];
        if(assocRecord !== undefined) {
          if (dependentAddOnsIdToAdd.includes(assocRecord.cspmb__add_on_price_item__c)) {
            remove(dependentAddOnsIdToAdd, function (currentItem) {
              return currentItem === assocRecord.cspmb__add_on_price_item__c;
            });
          }
        }
      });

      // invalidate configuration if addons from target group are missing
      each(addOnsFromGroupInclusion, function (targetGroups, assocId) {
        each(targetGroups, function (targetGroup) {
          var invalidateConfig = true;
          // check if this addon group has any optional records
          // if has optional records and source group is added - do not require target group
          var optionalListForAssocId = allOptionalAddOnDependencies[assocId];
          if (optionalListForAssocId !== undefined && optionalListForAssocId.length > 0) {
            each(optionalListForAssocId, function (listItem) {
              var sourceGroupOptional = listItem.group_source__c;
              var sourceAddOnOptional = listItem.add_on_source__c;
              var targetGroupOptional = listItem.group_target__c;
              var operationOptional = listItem.operation__c;

              if(operationOptional && !includes(operationOptional,contextOperation)){
                return;
              }

              if (sourceGroupOptional !== undefined && sourceGroupOptional !== '') {
                var assocGroupState = groupMinMaxValidation[sourceGroupOptional];
                if (assocGroupState !== undefined && targetGroup === targetGroupOptional) {
                  var currentValue = assocGroupState.current_count;

                  if (currentValue > 0) {
                    invalidateConfig = false;
                  }
                }
              }

              if (sourceAddOnOptional !== undefined && sourceAddOnOptional !== '') {
                each(currentlySelectedAddOnAssocIds, function (assocId) {
                  var assocRecord = mapAssocIdAssocRecord[assocId];
                  if (sourceAddOnOptional === assocRecord.cspmb__add_on_price_item__c) {
                    invalidateConfig = false;
                  }
                });
              }
            });
          }

          if (invalidateConfig) {
            addOnsFromGroupToInclude.push(targetGroup);
          }
        });
      });

      var addOnsForInclusionFinal = {};
      /// check MIN and MAX and prepare final list to return
      each(addOnsForInclusion, function (listItem, key) {
        each(mapAssocIdAssocRecord, function (assocValue, assocKey) {
          if (assocValue.cspmb__add_on_price_item__c === key) {
            var optionalListForAssocId = allOptionalAddOnDependencies[assocKey];
            if (optionalListForAssocId === undefined) {
              optionalListForAssocId = allOptionalAddOnDependencies[key];
            }
            var optional = false;
            if (optionalListForAssocId !== undefined && optionalListForAssocId.length > 0) {
              each(optionalListForAssocId, function (listItem) {
                if (listItem.add_on_target__c === assocValue.cspmb__add_on_price_item__c
                  && (listItem.add_on_source__c === undefined || currentlySelectedAddOnIds.includes(listItem.add_on_source__c))) {
                  optional = true;
                }
              });
            }

            // check on Association level - MIN and MAX within the Group
            var assocGroupState = groupMinMaxValidation[assocValue.cspmb__group__c];
            if (assocGroupState !== undefined) {
              var maxValue = assocGroupState.max_count;
              var currentValue = assocGroupState.current_count;

              if (currentValue < maxValue && !optional) {
                addOnsForInclusionFinal[key] = listItem;
              }
            }
          }
        });
      });

      // sort groups to remove messages in sequence defined order
      groupsToRemove.sort(function (a, b) {
        if (a.sequence === undefined) {
          return 1;
        } else if (b.sequence === undefined) {
          return -1;
        } else {
          return a.sequence - b.sequence;
        }
      });

      // update dependentAddOnsIdToAdd if some are not allowed to be added based on MIN and MAX
      // respect min and max for associations
      if (dependentAddOnsIdToAdd.length > 0) {
        each(mapAssocIdAssocRecord, function (assocValue, key) {
          each(dependentAddOnsIdToAdd, function (addOnId) {
            if (assocValue.cspmb__add_on_price_item__c === addOnId) {
              var assocGroupState = groupMinMaxValidation[assocValue.cspmb__group__c];
              if (assocGroupState !== undefined) {
                var maxValue = assocGroupState.max_count;
                var currentValue = assocGroupState.current_count;

                if (currentValue < maxValue) {
                  dependentAssociationsIdToAdd.push(key);
                }
              }
            }
          });
        });
      }

      //update dependentAddOnsIdToDelete if some are not allowed to be deleted
      if (dependentAddOnsIdToDelete.length > 0) {
        each(mapAssocIdAssocRecord, function (value, key) {
          each(dependentAddOnsIdToDelete, function (addOnId) {
            if (value.cspmb__add_on_price_item__c === addOnId && (value.cspmb__default_quantity__c === undefined ||
              value.cspmb__default_quantity__c < 1)) {
              var assocGroupState = groupMinMaxValidation[value.cspmb__group__c];
              if (assocGroupState !== undefined) {
                var minValue = assocGroupState.min_count;
                var currentValue = assocGroupState.current_count;

                if (currentValue > minValue) {
                  dependentAssociationsIdToDelete.push(key);
                }
              }
            }
          });
        });
      }

      // when "parent" AddOn in Mandatory dependency between AddOn Source and AddOn Target is deleted
      // find "children" and delete them too
      each(currentlySelectedAddOnAssocIds, function (selectedAssoc) {
        // get mandatory dependency records
        var depenRecordsForAssoc = allSatisfiedMandatoryAddOnDependencies[selectedAssoc];

        if (depenRecordsForAssoc !== undefined && depenRecordsForAssoc.length > 0) {
          // if its more than just "parent" and "child"
          // this is TRUE if PARENT -> CHILD -> GRANDCHILD relationship found
          var dependenciesExist = false;
          var superDependenciesExist = true;
          var parentFound = false;

          each(depenRecordsForAssoc, function (childValue) {
            var addOnTarget = childValue.add_on_target__c;
            var addOnSource = childValue.add_on_source__c;
            var campaignSource = childValue.campaign_promotion_source__c;


            // if this assoc is parent to some addon
            if (addOnSource === mapAssocIdAssocRecord[selectedAssoc].cspmb__add_on_price_item__c) {
              // this assoc is parent to some addon assoc and do not allow deletion of selectedAssoc
              dependenciesExist = true;
            }

            // need to check if parent assoc is currently added
            var enteredInParentCheck = false;

            // it will enter only if selectedAssoc is "child" AddOn Assoc to other AddOn Assoc and the source of the dependency records are not the campaign Promotions
            if ((campaignSource===undefined || campaignSource==='') && addOnTarget === mapAssocIdAssocRecord[selectedAssoc].cspmb__add_on_price_item__c) {
              enteredInParentCheck = true;
              // trying to find parent assoc record
              each(currentlySelectedAddOnAssocIds, function (parentAssocId) {
                var parentAssoc = mapAssocIdAssocRecord[parentAssocId];

                if (parentAssoc.cspmb__add_on_price_item__c === addOnSource || (addOnSource === undefined || addOnSource === '')) {
                  parentFound = true;
                  dependenciesExist = true;
                }
              });
            }

            // if this assoc is "child" of some MANDATORY relation and "parent" assoc wasnt found
            // delete this "child"
            if (enteredInParentCheck && !parentFound) {
              superDependenciesExist = false;
            }


            // check if "parent" is just being added in this iteration
            // skip deletion because of that
            // use case - when someone tries to delete middle AddOn in Mandatory dependency
            each(dependentAssociationsIdToAdd, function (assocIdToAdd) {
              var parentAssoc = mapAssocIdAssocRecord[assocIdToAdd];

              if (parentAssoc.cspmb__add_on_price_item__c === addOnSource) {
                dependenciesExist = true;
                superDependenciesExist = true;
              }
            });

            // if "child" is being currently added
            each(dependentAssociationsIdToAdd, function (assocIdToAdd) {
              var childAssoc = mapAssocIdAssocRecord[assocIdToAdd];

              if (childAssoc.cspmb__add_on_price_item__c === addOnTarget) {
                dependenciesExist = true;
              }
            });
            //if campaign promotion exists then let the addon be there
            if(getCurrentCampaignPromotionId()!==undefined && getCurrentCampaignPromotionId()!=='' && childValue.campaign_promotion_source__c===getCurrentCampaignPromotionId())
              dependenciesExist=true;
          });

          if (!dependenciesExist || (!superDependenciesExist && !parentFound)) {
            if (!includes(dependentAssociationsIdToDelete, selectedAssoc)) {
              dependentAssociationsIdToDelete.push(selectedAssoc);
            }
          }
        }

        // Delete target add ons when source is deleted (inclusion)
        // Check for inclusion add ons no longer valid.
        each(allInclusionAddOnDependencies, function (inclusionDependencyItem) {
          var satisfied = false;
          var assocRecord = mapAssocIdAssocRecord[selectedAssoc];
          each(satisfiedInclusionAddOnDependencies, function (satisfiedDependencyItem) {
            if (satisfiedDependencyItem.add_on_target__c === assocRecord.cspmb__add_on_price_item__c || satisfiedDependencyItem.group_target__c === assocRecord.cspmb__group__c) {
              satisfied = true;
            }
          });

          if (!satisfied) {
            if (inclusionDependencyItem.add_on_target__c === assocRecord.cspmb__add_on_price_item__c || inclusionDependencyItem.group_target__c === assocRecord.cspmb__group__c) {
              if (!includes(dependentAssociationsIdToDelete, selectedAssoc)) {
                dependentAssociationsIdToDelete.push(selectedAssoc);
              }
            }
          }
        });
      });

      resultMap.addOnsFromGroupToInclude = addOnsFromGroupToInclude;
      resultMap.groupsToRemove = groupsToRemove;
      //resultMap.addOnsToBeIncluded = addOnsToBeIncluded;
      resultMap.addOnsForInclusion = addOnsForInclusionFinal;
      resultMap.dependentAddOnsIdToAdd = dependentAddOnsIdToAdd;
      resultMap.dependentAssociationsIdToAdd = dependentAssociationsIdToAdd;
      resultMap.dependentAddOnsIdToDelete = dependentAddOnsIdToDelete;
      resultMap.dependentAssociationsIdToDelete = dependentAssociationsIdToDelete;
      resultMap.operationToPriceItem = operationToPriceItem;
      resultMap.dependentPriceItemtoAdd = dependentPriceItemtoAdd;
      resultMap.dependentPriceItemtoDelete = dependentPriceItemtoDelete;
    }

    resultMap.groupMinMaxValidation = groupMinMaxValidation;
    return resultMap;
  }

  function calculateDelta(newCommercialProductId,campaignPromotionIDSelected, currentlySelectedAddOnIds, newCommercialProductAddOnAssociations, dependencyRecords, newOfferAddOnIds, isMACD) {
    var resultMap = {
      addOnsToAdd:{},
      addOnsToRemove:{},
      groupsToAdd:{},
      groupsToRemove:{},
      groupMinMax:{},
      currentlySelectedAssociationAddOnIds:{}
    };

    var addOnsToAdd = new Set();
    var addOnsToRemove = new Set();
    var groupsToAdd = new Set();
    var groupsToRemove = new Set();
    var currentlySelectedAssociationAddOnIds = [];
    var assocMap = [];
    var addOnNamesMap = [];

    each(newCommercialProductAddOnAssociations, function(assoc) {
      assocMap[assoc.id] = assoc;
      addOnNamesMap[assoc.cspmb__add_on_price_item__r.name] = assoc.cspmb__add_on_price_item__c;

      if(currentlySelectedAddOnIds.includes(assoc.cspmb__add_on_price_item__c)) {
        currentlySelectedAssociationAddOnIds.push(assoc.id);
        currentlySelectedAddOnIds.remove(assoc.cspmb__add_on_price_item__c);
      }

      if(newOfferAddOnIds.includes(assoc.cspmb__add_on_price_item__c)) {
        currentlySelectedAssociationAddOnIds.push(assoc.id);
        newOfferAddOnIds.remove(assoc.cspmb__add_on_price_item__c);
      }
    });

    each(currentlySelectedAddOnIds, function(addOnId) {
      addOnsToRemove.add(addOnId);
    });

    init(newCommercialProductId,campaignPromotionIDSelected, newCommercialProductAddOnAssociations, dependencyRecords, isMACD, true);
    var availableAddOns = preDrawAssociationListFiltering(newCommercialProductAddOnAssociations,currentlySelectedAssociationAddOnIds,currentlySelectedAssociationAddOnIds);
    var dependencyResults = runDependencyEngine(currentlySelectedAssociationAddOnIds,null);

    each(dependencyResults.dependentAssociationsIdToAdd, function(assocId) {
      addOnsToAdd.add(assocMap[assocId].cspmb__add_on_price_item__c);
    });

    each(dependencyResults.addOnsFromGroupToInclude, function(groupName) {
      groupsToAdd.add(groupName);
    });

    each(dependencyResults.groupsToRemove, function(groupName) {
      groupsToRemove.add(groupName.targetGroup);
    });

    each(dependencyResults.addOnsToBeIncluded, function(addOnId) {
      addOnsToAdd.add(addOnId);
    });

    each(dependencyResults.dependentAddOnsIdToAdd, function(addOnId) {
      addOnsToAdd.add(addOnId);
    });

    each(dependencyResults.dependentAddOnsIdToDelete, function(addOnId) {
      addOnsToRemove.add(addOnId);
    });

    each(dependencyResults.dependentAssociationsIdToDelete, function(assocId) {
      addOnsToRemove.add(assocMap[assocId].cspmb__add_on_price_item__c);
    });

    each(dependencyResults.addOnsForInclusion, function(addOnId) {
      addOnsToAdd.add(addOnNamesMap[addOnId[0].targetAddOnName]);
    });

    resultMap.addOnsToAdd = Array.from(addOnsToAdd);
    resultMap.addOnsToRemove = Array.from(addOnsToRemove);
    resultMap.groupsToAdd = Array.from(groupsToAdd);
    resultMap.groupsToRemove = Array.from(groupsToRemove);
    resultMap.groupMinMax = dependencyResults.groupMinMaxValidation;
    resultMap.currentlySelectedAssociationAddOnIds = currentlySelectedAssociationAddOnIds;
    return resultMap;
  }

  /**
   * @param allDependencyRecords
   *  dependencyRecord object array from add-on-rules API
   * @param offerTransitionPriorityMap
   *  example { "commercialProductObjectId": otpValue, "a27UD000000dB6UYAU": 90 }
   * @param sourceCommercialProductId
   *  commercialProductObjectId of the subscription from where MACD will happen
   * @param targetCommercialProductIds
   *  list of commercialProductObjectIds to which MACD is supposed to be performed
   * @returns
   *  example { "commercialProductObjectId": {
   *      priceItemId: "service-fee-product-object-id",
   *      price: serviceFeeProductOCPrice
   *    }}
   */
  function getPriceItemAndServiceFeesMap(
    allDependencyRecords,
    offerTransitionPriorityMap,
    sourceCommercialProductId,
    targetCommercialProductIds
  ) {
    const getOperation = targetId => {
      const sourceOtp = offerTransitionPriorityMap[sourceCommercialProductId];
      const targetOtp = offerTransitionPriorityMap[targetId];
      if (sourceOtp === undefined || targetOtp === undefined || sourceOtp === targetOtp) {
        return 'Offer Change';
      }
      return sourceOtp - targetOtp < 0 ? 'Offer Upgrade' : 'Offer Downgrade';
    };

    /* example serviceFeeMap = {
      "commercialProductObjectId": { priceItemId: "service-fee-product-object-id", price: serviceFeeProductOCPrice },
      "a27UD000000dB6UYAU": { priceItemId: "a27UD000000dE6LYAU", price: 899 },
      "a27UD000000dB7UYAU": { priceItemId: "a27UD000000dB8UYAU", price: 399 },
    } */
    const serviceFeeMap = {};

    // populate serviceFeeMap
    targetCommercialProductIds.forEach(targetCommercialProductId => {
      allDependencyRecords
        .filter(depRecord => depRecord.price_item__c === targetCommercialProductId)
        .filter(depRecord => depRecord.price_item_target__c && depRecord.price_item_target__r && depRecord.operation__c)
        .filter(depRecord => depRecord.operation__c === getOperation(targetCommercialProductId))
        .forEach(depRecord => {
          const depRecordPrice = depRecord.price_item_target__r.one_off_charge_online__c || 0;
          const depRecordProductId = depRecord.price_item_target__c;

          serviceFeeMap[targetCommercialProductId] = {
            price: depRecordPrice * 100,
            priceItemId: depRecordProductId
          };
        });
    });

    return serviceFeeMap;
  }

  return {
    init: init,
    getCurrentCommercialProductId: getCurrentCommercialProductId,
    getCurrentCommercialProductDetails: getCurrentCommercialProductDetails,
    preDrawAssociationListFiltering: preDrawAssociationListFiltering,
    runDependencyEngine: runDependencyEngine,
    setCurrentCampaignPromotionId:setCurrentCampaignPromotionId,
    getCurrentCampaignPromotionId:getCurrentCampaignPromotionId,
    getMandatoryTargetAddOns: getMandatoryTargetAddOns,
    calculateDelta: calculateDelta,
    getPriceItemAndServiceFeesMap: getPriceItemAndServiceFeesMap,
  };
}

export const getRequiredDependencyActions = (
  commercialProductId,
  allAssociationRecords,
  allDependencyRecords,
  selectedAssociationIds,
  selectedCampaignPromotionId,
  commercialProductIdList,
  changeContext) => {
  const addOnManager = buildAddOnManagerFunctions();
  const commercialProductAssociationRecords =
    allAssociationRecords.filter(assocRecord => assocRecord.cspmb__price_item__c === commercialProductId);
  addOnManager.init(
    commercialProductId,
    selectedCampaignPromotionId,
    commercialProductAssociationRecords,
    allDependencyRecords,
    true,
    true,
    commercialProductIdList
  );
  addOnManager.preDrawAssociationListFiltering(commercialProductAssociationRecords, selectedAssociationIds, selectedAssociationIds);
  return addOnManager.runDependencyEngine(selectedAssociationIds, changeContext);
};

export const getAssociationsAvailability = (
  commercialProductId,
  allAssociationRecords,
  allDependencyRecords,
  selectedAssociationIds,
  selectedCampaignPromotionId,
  commercialProductIdList) => {
  const addOnManager = buildAddOnManagerFunctions();
  const commercialProductAssociationRecords =
    allAssociationRecords.filter(assocRecord => assocRecord.cspmb__price_item__c === commercialProductId);
  addOnManager.init(
    commercialProductId,
    selectedCampaignPromotionId,
    commercialProductAssociationRecords,
    allDependencyRecords,
    true,
    true,
    commercialProductIdList
  );
  return addOnManager.preDrawAssociationListFiltering(commercialProductAssociationRecords, selectedAssociationIds, selectedAssociationIds);
};

export const getListOfServiceFeesByProductIds = (
  allDependencyRecords,
  offerTransitionPriorityMap,
  sourceCommercialProductId,
  targetCommercialProductIds
) => {
  const addOnManager = buildAddOnManagerFunctions();
  return addOnManager.getPriceItemAndServiceFeesMap(
    allDependencyRecords,
    offerTransitionPriorityMap,
    sourceCommercialProductId,
    targetCommercialProductIds
  );
};
